<template>
  <div>
    <div v-if="salutation === 'f' && surname" class="simple-service__title">{{$t('simpleService.femaleSalutation')}} {{surname}},</div>
    <div v-else-if="salutation === 'm' && surname" class="simple-service__title">{{$t('simpleService.maleSalutation')}} {{surname}},</div>
    <div v-else class="simple-service__title">{{$t('simpleService.neutralSalutation')}},</div>
  </div>
</template>

<script>
export default {
  name: 'Salutation',
  props: {
    salutation: {
      type: String,
      default: ''
    },
    surname: {
      type: String,
      default: ''
    }
  }
}
</script>
